import { render, staticRenderFns } from "./cargoComboBox.vue?vue&type=template&id=a150aa50&"
import script from "./cargoComboBox.vue?vue&type=script&lang=js&"
export * from "./cargoComboBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a150aa50')) {
      api.createRecord('a150aa50', component.options)
    } else {
      api.reload('a150aa50', component.options)
    }
    module.hot.accept("./cargoComboBox.vue?vue&type=template&id=a150aa50&", function () {
      api.rerender('a150aa50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoComboBox.vue"
export default component.exports